
import LoadingBar from '~/components/common/LoadingBar'

export default {
  name: 'DefaultLayouts',
  components: { LoadingBar },
  mounted () {
    if (!localStorage.getItem('api_v2')) {
      localStorage.setItem('api_v2', 'true')
    }

    console.log('kakao call start')
    try { window.kakaoPixel('7573203864979226263').pageView() } catch (e) {}
    console.log('kakao call end')
  }
}
